(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emilie-candle-landing"] && !Shopify.designMode) return;
  try {
    

  // Register once; custom elements initialise again after Shopify editor section reloads.
  if (!customElements.get('emilie-landing-gallery-v3')) {
    customElements.define('emilie-landing-gallery-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
        if (this.cleanup) return;
        const slides = Array.from(this.querySelectorAll('[data-el-slide]'));
        const nav = this.querySelector('[data-el-gallery-nav]');
        const track = this.querySelector('[data-el-thumbs]');
        const previous = this.querySelector('[data-el-prev]');
        const next = this.querySelector('[data-el-next]');
        const status = this.querySelector('[data-el-gallery-status]');
        if (slides.length < 2 || !nav || !track || !previous || !next) return;
        let current = 0;
        track.replaceChildren();
        const thumbs = slides.map((slide, index) => {
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'el-landing__gallery-thumb';
          thumb.dataset.elIndex = String(index);
          thumb.setAttribute('aria-controls', slide.id);
          thumb.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
          const label = slide.dataset.label || String(index + 1);
          thumb.setAttribute('aria-label', (this.dataset.showLabel || 'Show') + ': ' + label);
          if (slide.dataset.thumb) {
            const image = document.createElement('img');
            image.src = slide.dataset.thumb;
            image.alt = '';
            image.width = 80;
            image.height = 80;
            image.loading = 'lazy';
            thumb.append(image);
          } else {
            thumb.textContent = String(index + 1);
          }
          if (slide.dataset.kind === 'video') {
            const icon = document.createElement('span');
            icon.className = 'el-landing__thumb-play';
            icon.textContent = '▶';
            icon.setAttribute('aria-hidden', 'true');
            thumb.append(icon);
            thumb.setAttribute('aria-label', thumb.getAttribute('aria-label') + ' (' + (this.dataset.videoLabel || 'video') + ')');
          }
          track.append(thumb);
          return thumb;
        });
        const show = (index, focusThumb = false) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          slides.forEach((slide, i) => {
            slide.hidden = i !== target;
            if (i !== target) slide.querySelectorAll('video').forEach(video => video.pause());
            thumbs[i].setAttribute('aria-pressed', i === target ? 'true' : 'false');
          });
          current = target;
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
          const thumb = thumbs[current];
          const thumbLeft = thumb.offsetLeft - track.offsetLeft;
          const thumbRight = thumbLeft + thumb.offsetWidth;
          if (thumbLeft < track.scrollLeft) track.scrollLeft = thumbLeft;
          else if (thumbRight > track.scrollLeft + track.clientWidth) track.scrollLeft = thumbRight - track.clientWidth;
          if (focusThumb) thumb.focus({ preventScroll: true });
          if (status) status.textContent = (current + 1) + ' ' + (this.dataset.ofLabel || 'of') + ' ' + slides.length + ': ' + (slides[current].dataset.label || '');
          slides[current].dispatchEvent(new CustomEvent('emilie:gallery-visible', { bubbles: true }));
        };
        const click = event => {
          const thumb = event.target.closest('[data-el-index]');
          if (thumb && track.contains(thumb)) show(Number(thumb.dataset.elIndex));
          else if (event.target.closest('[data-el-prev]') === previous) show(current - 1);
          else if (event.target.closest('[data-el-next]') === next) show(current + 1);
        };
        const keydown = event => {
          if (!nav.contains(event.target)) return;
          let target;
          if (event.key === 'ArrowLeft') target = current - 1;
          else if (event.key === 'ArrowRight') target = current + 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = slides.length - 1;
          else return;
          event.preventDefault();
          show(target, true);
        };
        const blockSelect = event => {
          const slide = event.target.closest('[data-el-slide]');
          if (slide && slides.includes(slide)) show(slides.indexOf(slide));
        };
        this.addEventListener('click', click);
        this.addEventListener('keydown', keydown);
        this.addEventListener('shopify:block:select', blockSelect);
        nav.hidden = false;
        show(Math.max(0, slides.findIndex(slide => !slide.hidden)));
        this.cleanup = () => {
          this.removeEventListener('click', click);
          this.removeEventListener('keydown', keydown);
          this.removeEventListener('shopify:block:select', blockSelect);
        };
      }
      disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
    });
  }

  if (!customElements.get('emilie-landing-video-v3')) {
    customElements.define('emilie-landing-video-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
        if (this.cleanup) return;
        const video = this.querySelector('video');
        const toggle = this.querySelector('button');
        if (!video || !toggle || !this.hasAttribute('data-autoplay')) return;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let visible = false;
        let userPaused = false;
        let playPending = false;
        const inactiveSlide = () => !!this.closest('[data-el-slide][hidden]');
        const sync = () => {
          toggle.setAttribute('aria-label', video.paused ? (this.dataset.playLabel || 'Play video') : (this.dataset.pauseLabel || 'Pause video'));
          const icon = toggle.querySelector('span');
          if (icon) icon.textContent = video.paused ? '▶' : 'Ⅱ';
        };
        const play = () => {
          if (playPending || inactiveSlide() || this.hasAttribute('data-editor-hold')) return;
          video.muted = true;
          playPending = true;
          const result = video.play();
          if (result && typeof result.catch === 'function') {
            result.catch(error => {
              if (error.name !== 'AbortError') { video.controls = true; toggle.hidden = true; }
            }).finally(() => { playPending = false; });
          } else playPending = false;
        };
        const update = () => {
          if (this.hasAttribute('data-editor-hold')) { video.pause(); return; }
          if (motion.matches || navigator.connection?.saveData) {
            video.autoplay = false;
            video.pause();
            video.controls = true;
            toggle.hidden = true;
          } else if (visible && !document.hidden && !userPaused && !inactiveSlide()) {
            play();
          } else video.pause();
        };
        const onPlay = () => {
          if (inactiveSlide() || document.hidden || this.hasAttribute('data-editor-hold')) { video.pause(); return; }
          const nativeControls = motion.matches || navigator.connection?.saveData;
          video.controls = !!nativeControls;
          toggle.hidden = !!nativeControls;
          sync();
        };
        const onToggle = () => {
          userPaused = !video.paused;
          if (userPaused) video.pause(); else play();
        };
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', sync);
        toggle.addEventListener('click', onToggle);
        motion.addEventListener('change', update);
        document.addEventListener('visibilitychange', update);
        let observer;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(entries => {
            visible = entries[0].isIntersecting;
            update();
          }, { threshold: 0.15 });
          observer.observe(this);
        } else {
          video.autoplay = false;
          video.controls = true;
          toggle.hidden = true;
        }
        const slide = this.closest('[data-el-slide]');
        const onGalleryVisible = () => {
          // IntersectionObserver is the source of visibility; this also handles rapid switches.
          if (slide?.hidden) video.pause(); else update();
        };
        slide?.addEventListener('emilie:gallery-visible', onGalleryVisible);
        if (!video.paused) onPlay();
        this.cleanup = () => {
          observer?.disconnect();
          video.pause();
          video.removeEventListener('play', onPlay);
          video.removeEventListener('pause', sync);
          toggle.removeEventListener('click', onToggle);
          motion.removeEventListener('change', update);
          document.removeEventListener('visibilitychange', update);
          slide?.removeEventListener('emilie:gallery-visible', onGalleryVisible);
        };
      }
      disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
    });
  }

/* The content order is the block order; app blocks are never moved elsewhere. */
if (!customElements.get('emilie-editor-section-v3')) {
  customElements.define('emilie-editor-section-v3', class extends HTMLElement {
    connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
      if (this.cleanup) return;
      const openState = new WeakMap();
      const onSelect = event => {
        const block = event.target.closest('.el-editable__block, [data-el-slide]');
        if (!block || !this.contains(block)) return;
        block.setAttribute('data-el-editor-selected', '');
        const faq = block.querySelector('[data-el-faq]');
        if (faq) { if (!openState.has(faq)) openState.set(faq, faq.open); faq.open = true; }
        block.querySelectorAll('emilie-landing-video-v3').forEach(player => {
          player.setAttribute('data-editor-hold', '');
          player.querySelector('video')?.pause();
        });
      };
      const onDeselect = event => {
        const block = event.target.closest('.el-editable__block, [data-el-slide]');
        if (!block || !this.contains(block)) return;
        block.removeAttribute('data-el-editor-selected');
        const faq = block.querySelector('[data-el-faq]');
        if (faq && openState.has(faq)) { faq.open = openState.get(faq); openState.delete(faq); }
        block.querySelectorAll('emilie-landing-video-v3').forEach(player => player.removeAttribute('data-editor-hold'));
      };
      const onClick = event => {
        const link = event.target.closest('a[data-el-destination]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = link.dataset.elDestination;
        if (!['sets','wax','top'].includes(destination)) return;
        const target = destination === 'top'
          ? document.querySelector('emilie-editor-section-v3.el-editable--hero')
          : document.querySelector('emilie-editor-section-v3[data-el-group="' + destination + '"]');
        // Keep the original href usable without JavaScript.
        if (!target) return;
        event.preventDefault();
        target.style.scrollMarginTop = getComputedStyle(this).getPropertyValue('--el-anchor-offset');
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };
      this.addEventListener('shopify:block:select', onSelect);
      this.addEventListener('shopify:block:deselect', onDeselect);
      this.addEventListener('click', onClick);
      this.cleanup = () => {
        this.removeEventListener('shopify:block:select', onSelect);
        this.removeEventListener('shopify:block:deselect', onDeselect);
        this.removeEventListener('click', onClick);
      };
    }
    disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emilie-landing-content"] && !Shopify.designMode) return;
  try {
    

  // Register once; custom elements initialise again after Shopify editor section reloads.
  if (!customElements.get('emilie-landing-gallery-v3')) {
    customElements.define('emilie-landing-gallery-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
        if (this.cleanup) return;
        const slides = Array.from(this.querySelectorAll('[data-el-slide]'));
        const nav = this.querySelector('[data-el-gallery-nav]');
        const track = this.querySelector('[data-el-thumbs]');
        const previous = this.querySelector('[data-el-prev]');
        const next = this.querySelector('[data-el-next]');
        const status = this.querySelector('[data-el-gallery-status]');
        if (slides.length < 2 || !nav || !track || !previous || !next) return;
        let current = 0;
        track.replaceChildren();
        const thumbs = slides.map((slide, index) => {
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'el-landing__gallery-thumb';
          thumb.dataset.elIndex = String(index);
          thumb.setAttribute('aria-controls', slide.id);
          thumb.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
          const label = slide.dataset.label || String(index + 1);
          thumb.setAttribute('aria-label', (this.dataset.showLabel || 'Show') + ': ' + label);
          if (slide.dataset.thumb) {
            const image = document.createElement('img');
            image.src = slide.dataset.thumb;
            image.alt = '';
            image.width = 80;
            image.height = 80;
            image.loading = 'lazy';
            thumb.append(image);
          } else {
            thumb.textContent = String(index + 1);
          }
          if (slide.dataset.kind === 'video') {
            const icon = document.createElement('span');
            icon.className = 'el-landing__thumb-play';
            icon.textContent = '▶';
            icon.setAttribute('aria-hidden', 'true');
            thumb.append(icon);
            thumb.setAttribute('aria-label', thumb.getAttribute('aria-label') + ' (' + (this.dataset.videoLabel || 'video') + ')');
          }
          track.append(thumb);
          return thumb;
        });
        const show = (index, focusThumb = false) => {
          const target = Math.max(0, Math.min(slides.length - 1, index));
          slides.forEach((slide, i) => {
            slide.hidden = i !== target;
            if (i !== target) slide.querySelectorAll('video').forEach(video => video.pause());
            thumbs[i].setAttribute('aria-pressed', i === target ? 'true' : 'false');
          });
          current = target;
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
          const thumb = thumbs[current];
          const thumbLeft = thumb.offsetLeft - track.offsetLeft;
          const thumbRight = thumbLeft + thumb.offsetWidth;
          if (thumbLeft < track.scrollLeft) track.scrollLeft = thumbLeft;
          else if (thumbRight > track.scrollLeft + track.clientWidth) track.scrollLeft = thumbRight - track.clientWidth;
          if (focusThumb) thumb.focus({ preventScroll: true });
          if (status) status.textContent = (current + 1) + ' ' + (this.dataset.ofLabel || 'of') + ' ' + slides.length + ': ' + (slides[current].dataset.label || '');
          slides[current].dispatchEvent(new CustomEvent('emilie:gallery-visible', { bubbles: true }));
        };
        const click = event => {
          const thumb = event.target.closest('[data-el-index]');
          if (thumb && track.contains(thumb)) show(Number(thumb.dataset.elIndex));
          else if (event.target.closest('[data-el-prev]') === previous) show(current - 1);
          else if (event.target.closest('[data-el-next]') === next) show(current + 1);
        };
        const keydown = event => {
          if (!nav.contains(event.target)) return;
          let target;
          if (event.key === 'ArrowLeft') target = current - 1;
          else if (event.key === 'ArrowRight') target = current + 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = slides.length - 1;
          else return;
          event.preventDefault();
          show(target, true);
        };
        const blockSelect = event => {
          const slide = event.target.closest('[data-el-slide]');
          if (slide && slides.includes(slide)) show(slides.indexOf(slide));
        };
        this.addEventListener('click', click);
        this.addEventListener('keydown', keydown);
        this.addEventListener('shopify:block:select', blockSelect);
        nav.hidden = false;
        show(Math.max(0, slides.findIndex(slide => !slide.hidden)));
        this.cleanup = () => {
          this.removeEventListener('click', click);
          this.removeEventListener('keydown', keydown);
          this.removeEventListener('shopify:block:select', blockSelect);
        };
      }
      disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
    });
  }

  if (!customElements.get('emilie-landing-video-v3')) {
    customElements.define('emilie-landing-video-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
        if (this.cleanup) return;
        const video = this.querySelector('video');
        const toggle = this.querySelector('button');
        if (!video || !toggle || !this.hasAttribute('data-autoplay')) return;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        let visible = false;
        let userPaused = false;
        let playPending = false;
        const inactiveSlide = () => !!this.closest('[data-el-slide][hidden]');
        const sync = () => {
          toggle.setAttribute('aria-label', video.paused ? (this.dataset.playLabel || 'Play video') : (this.dataset.pauseLabel || 'Pause video'));
          const icon = toggle.querySelector('span');
          if (icon) icon.textContent = video.paused ? '▶' : 'Ⅱ';
        };
        const play = () => {
          if (playPending || inactiveSlide() || this.hasAttribute('data-editor-hold')) return;
          video.muted = true;
          playPending = true;
          const result = video.play();
          if (result && typeof result.catch === 'function') {
            result.catch(error => {
              if (error.name !== 'AbortError') { video.controls = true; toggle.hidden = true; }
            }).finally(() => { playPending = false; });
          } else playPending = false;
        };
        const update = () => {
          if (this.hasAttribute('data-editor-hold')) { video.pause(); return; }
          if (motion.matches || navigator.connection?.saveData) {
            video.autoplay = false;
            video.pause();
            video.controls = true;
            toggle.hidden = true;
          } else if (visible && !document.hidden && !userPaused && !inactiveSlide()) {
            play();
          } else video.pause();
        };
        const onPlay = () => {
          if (inactiveSlide() || document.hidden || this.hasAttribute('data-editor-hold')) { video.pause(); return; }
          const nativeControls = motion.matches || navigator.connection?.saveData;
          video.controls = !!nativeControls;
          toggle.hidden = !!nativeControls;
          sync();
        };
        const onToggle = () => {
          userPaused = !video.paused;
          if (userPaused) video.pause(); else play();
        };
        video.addEventListener('play', onPlay);
        video.addEventListener('pause', sync);
        toggle.addEventListener('click', onToggle);
        motion.addEventListener('change', update);
        document.addEventListener('visibilitychange', update);
        let observer;
        if ('IntersectionObserver' in window) {
          observer = new IntersectionObserver(entries => {
            visible = entries[0].isIntersecting;
            update();
          }, { threshold: 0.15 });
          observer.observe(this);
        } else {
          video.autoplay = false;
          video.controls = true;
          toggle.hidden = true;
        }
        const slide = this.closest('[data-el-slide]');
        const onGalleryVisible = () => {
          // IntersectionObserver is the source of visibility; this also handles rapid switches.
          if (slide?.hidden) video.pause(); else update();
        };
        slide?.addEventListener('emilie:gallery-visible', onGalleryVisible);
        if (!video.paused) onPlay();
        this.cleanup = () => {
          observer?.disconnect();
          video.pause();
          video.removeEventListener('play', onPlay);
          video.removeEventListener('pause', sync);
          toggle.removeEventListener('click', onToggle);
          motion.removeEventListener('change', update);
          document.removeEventListener('visibilitychange', update);
          slide?.removeEventListener('emilie:gallery-visible', onGalleryVisible);
        };
      }
      disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
    });
  }

/* The content order is the block order; app blocks are never moved elsewhere. */
if (!customElements.get('emilie-editor-section-v3')) {
  customElements.define('emilie-editor-section-v3', class extends HTMLElement {
    connectedCallback() {
        if (this.cleanup || this.initTimer) return;
        this.initTimer = setTimeout(() => { this.initTimer = null; if (this.isConnected) this.initialize(); }, 0);
      }
      initialize() {
      if (this.cleanup) return;
      const openState = new WeakMap();
      const onSelect = event => {
        const block = event.target.closest('.el-editable__block, [data-el-slide]');
        if (!block || !this.contains(block)) return;
        block.setAttribute('data-el-editor-selected', '');
        const faq = block.querySelector('[data-el-faq]');
        if (faq) { if (!openState.has(faq)) openState.set(faq, faq.open); faq.open = true; }
        block.querySelectorAll('emilie-landing-video-v3').forEach(player => {
          player.setAttribute('data-editor-hold', '');
          player.querySelector('video')?.pause();
        });
      };
      const onDeselect = event => {
        const block = event.target.closest('.el-editable__block, [data-el-slide]');
        if (!block || !this.contains(block)) return;
        block.removeAttribute('data-el-editor-selected');
        const faq = block.querySelector('[data-el-faq]');
        if (faq && openState.has(faq)) { faq.open = openState.get(faq); openState.delete(faq); }
        block.querySelectorAll('emilie-landing-video-v3').forEach(player => player.removeAttribute('data-editor-hold'));
      };
      const onClick = event => {
        const link = event.target.closest('a[data-el-destination]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const destination = link.dataset.elDestination;
        if (!['sets','wax','top'].includes(destination)) return;
        const target = destination === 'top'
          ? document.querySelector('emilie-editor-section-v3.el-editable--hero')
          : document.querySelector('emilie-editor-section-v3[data-el-group="' + destination + '"]');
        // Keep the original href usable without JavaScript.
        if (!target) return;
        event.preventDefault();
        target.style.scrollMarginTop = getComputedStyle(this).getPropertyValue('--el-anchor-offset');
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };
      this.addEventListener('shopify:block:select', onSelect);
      this.addEventListener('shopify:block:deselect', onDeselect);
      this.addEventListener('click', onClick);
      this.cleanup = () => {
        this.removeEventListener('shopify:block:select', onSelect);
        this.removeEventListener('shopify:block:deselect', onDeselect);
        this.removeEventListener('click', onClick);
      };
    }
    disconnectedCallback() { clearTimeout(this.initTimer); this.initTimer = null; this.cleanup?.(); this.cleanup = null; }
  });
}


  } catch(e) { console.error(e); }
})();
})();
